import {DateType, EnumType, JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {ContextoIntegracaoGRPEnum} from "../enums/contexto.integracao.grp.enum";
import {Municipio} from "./municipio";

@JacksonType("ExecucaoIntegracaoGRP")
@JsonIdentityInfo()
export class ExecucaoIntegracaoGRP extends SonnerBaseEntity {
  id: number;

  @JacksonType("Municipio")
  municipio: Municipio;

  @EnumType(ContextoIntegracaoGRPEnum)
  tipoIntegracao: ContextoIntegracaoGRPEnum;

  @DateType()
  execucao: Date;
}
